import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { PaginationParams } from "../type";
import { commonServices } from "./common.services";
import { COMMON_KEYS } from "./key";

export const useGetLocations = (params?: PaginationParams) => {
  return useQuery({
    queryKey: COMMON_KEYS.GET_LOCATIONS(params),
    queryFn: () => commonServices.getLocations(params),
  });
};

export const useGetLocationsInfinite = (params?: PaginationParams) => {
  return useInfiniteQuery({
    queryKey: COMMON_KEYS.GET_INFINITE_LOCATIONS(params),
    queryFn: ({ pageParam }) =>
      commonServices.getLocations({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) => {
      const { currentPage, totalPages } = lastPage.meta;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    initialPageParam: 1,
  });
};

export const useGetCountries = () => {
  return useQuery({
    queryKey: COMMON_KEYS.GET_COUNTRIES(),
    queryFn: () => commonServices.getCountries(),
  });
};

export const useGetStaffRoles = () => {
  return useQuery({
    queryKey: COMMON_KEYS.GET_STAFF_ROLES(),
    queryFn: () => commonServices.getStaffRoles(),
  });
};

export const useGetStaffRoleByName = (name: string, clientId?: string) => {
  return useQuery({
    queryKey: COMMON_KEYS.GET_STAFF_ROLE_BY_NAME(name, clientId),
    queryFn: () => commonServices.getStaffRoleByName(name, clientId),
    enabled: !!name,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes since staff roles don't change often
  });
};

export const useGetFileMimetype = (fileUrl?: string) => {
  return useQuery({
    queryKey: COMMON_KEYS.GET_FILE_MIMETYPE(fileUrl),
    queryFn: () => commonServices.getFileMimetype(fileUrl),
    enabled: !!fileUrl,
  });
};
